import { CommonModule, JsonPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { OwlDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { EVSidebarService } from '../ev-sidebar/ev-sidebar.service';

@Component({
  selector: 'app-ev-search',
  templateUrl: './ev-search.component.html',
  styleUrls: ['./ev-search.component.scss'],
  standalone: true,
  imports: [
    MatToolbarModule,
    MatIconModule,
    FormsModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    JsonPipe,
    MatToolbarModule,
    MatIconModule,
    MatOptionModule,
    MatSelectModule,
    OwlDateTimeModule,
    MatButtonModule,
    CommonModule,
    MatCheckboxModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
  ],
})
export class EvSearchComponent implements OnInit {
  public form: UntypedFormGroup;

  constructor(
    private readonly fb: UntypedFormBuilder,
    private readonly sidebarService: EVSidebarService,
  ) {}

  ngOnInit() {
    this.initialiseSearchForm();
  }

  public closeSidePanel() {
    this.sidebarService.clearSidebarMode();
  }

  public initialiseSearchForm(): void {
    this.form = this.fb.group({
      search: [null, []],
    });
  }

  search() {}

  reset() {
    this.form.reset();
  }
}
